/**
 * Утилиты для парсинга конфигурации виджета из URL параметров
 */

const WIDGET_ROUTE_PATHS = ['/widget', '/chat-widget'];

/**
 * Проверяет, что текущий роут - это встраиваемый виджет (/widget, /chat-widget).
 * Используется, чтобы не выполнять на этих роутах лишние запросы (авторизация,
 * список одежды и т.п.), не нужные внутри iframe на сайте клиента.
 * @param {string} [pathname] - путь для проверки, по умолчанию текущий
 * @returns {boolean}
 */
export const isWidgetRoute = (pathname = window.location.pathname) => {
  return WIDGET_ROUTE_PATHS.includes(pathname);
};

/**
 * Парсит параметры виджета из URL
 * @returns {Object} Конфигурация виджета
 */
export const parseWidgetConfig = () => {
  const urlParams = new URLSearchParams(window.location.search);
  
  return {
    apiKey: urlParams.get('api_key'),
    apiUrl: urlParams.get('apiUrl') || urlParams.get('api_url'),
    theme: {
      primaryColor: urlParams.get('primaryColor') || '#6366f1',
      backgroundColor: urlParams.get('backgroundColor') || '#ffffff',
      textColor: urlParams.get('textColor') || '#111827',
      buttonTextColor: urlParams.get('buttonTextColor') || '#ffffff',
      borderRadius: urlParams.get('borderRadius') || '0.5rem',
    },
    url: urlParams.get('url'),
  };
};

/**
 * Получает URL страницы для поиска одежды
 * @param {string} customUrl - Кастомный URL из параметров
 * @returns {string} URL для поиска
 */
export const getWebsiteURL = (customUrl) => {
  if (customUrl) {
    return customUrl;
  }

  if (document.referrer && document.referrer !== window.location.href) {
    return document.referrer;
  }

  try {
    if (window.parent && window.parent !== window) {
      return window.parent.location.href;
    }
  } catch (e) {
    // Cross-origin ограничение
  }

  return window.location.href;
};

/**
 * Нормализует URL (убирает query параметры и hash)
 * @param {string} url - URL для нормализации
 * @returns {string} Нормализованный URL
 */
export const normalizeURL = (url) => {
  try {
    const normalizedURL = new URL(url);
    normalizedURL.search = '';
    normalizedURL.hash = '';
    return normalizedURL.toString();
  } catch (e) {
    console.warn('Could not parse URL:', url);
    return url;
  }
};

